<template>
  <v-form ref="form" class="">

    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <div class="title my-3 d-block d-lg-none" id="purchaseSummary">
      <div class="d-md-inline-block">
        Compra: <b v-if="entry.totalPrice" class="green--text mr-md-4 float-right ml-md-3"> {{entry.totalPrice | formatCurrency}} </b> <b v-else class="black--text mr-4 float-right ml-md-3">R$ 0,00</b>
      </div>
      <div class="d-md-inline-block">
        Pagamentos: <b v-if="entry.totalPrice" :class="'float-right ml-md-3 ' + (entry.totalPrice == purchaseTotalPayment ? 'green--text' : 'red--text')"> {{purchaseTotalPayment | formatCurrency}} </b> <b v-else class="black--text mr-4 float-right ml-md-3">R$ 0,00</b>
      </div>
    </div>

    <v-tabs>
      <v-tab>Geral
      <v-tooltip top v-if="geralError">
          <template v-slot:activator="{ on }">
            <v-icon
              right
              color="error"
              v-on="on"
            >
              mdi-alert-circle-outline
            </v-icon>
          </template>
          <span>Existem erros no cadastro que devem ser resolvidos!</span>
        </v-tooltip>
      </v-tab>
      <!-- <v-tab>Entrega/Frete</v-tab> -->
      <v-tab>Pagamentos</v-tab>

      <v-spacer></v-spacer>
      <div class="title mt-3 d-none d-lg-block" id="purchaseSummary">
        Total da Compra: <b v-if="entry.totalPrice" class="green--text mr-4"> {{entry.totalPrice | formatCurrency}} </b> <b v-else class="black--text mr-4">R$ 0,00</b>
        Total de Pagamentos: <b v-if="entry.totalPrice" :class="entry.totalPrice == purchaseTotalPayment ? 'green--text' : 'red--text' "> {{purchaseTotalPayment | formatCurrency}} </b> <b v-else class="black--text mr-4">R$ 0,00</b>
      </div>


      <v-tab-item>
        <v-row>

          <!-- <v-col cols="12" sm="12" v-if="!isEdit">
            <v-file-input label="Importar nota (XML)" variant="underlined" v-model="file"></v-file-input>
          </v-col> -->

          <v-col cols="6" sm="6" md="3">
            <MaskedTextField
              v-bind="getObject('code')"
              :inputData.sync="entry.code"
              mask-type="integer"
              label="Código"
              readonly
              :disabled="readOnly || partialReadOnly"
              autocomplete="off"
            />
          </v-col>

          <v-col cols="6" sm="6" md="3">
            <v-text-field
              v-model="entry.series"
              v-bind="getObject('series')"
              label="Série da NF-e"
              :disabled="readOnly"
              autocomplete="off"
            />
          </v-col>

          <v-col cols="12" sm="9" md="6">
            <v-text-field
              v-model="entry.number"
              v-bind="getObject('number')"
              label="Número da NF-e"
              :disabled="readOnly"
              autocomplete="off"
            />
          </v-col>

          <v-col cols="12" sm="12" md="12">
            <v-autocomplete
              v-model="entry.cfopId"
              v-bind="getObject('cfopId')"
              label="Cfop"
              :items="extraData.accountContext.allPurchaseCfops"
              item-value="id"
              item-text="text"
              :disabled="readOnly || partialReadOnly"
              autocomplete="off"
            >
            </v-autocomplete>
          </v-col>

          <v-col cols="12" sm="12" md="6">
            <v-text-field v-if="entry.buyerName"
              v-model="entry.buyerName"
              v-bind="getObject('buyerName')"

              label="Comprador encontrado na nota"
              readonly
              autocomplete="off"
            />
            <v-autocomplete
              v-model="entry.customerId"
              v-bind="getObject('customerId')"
              label="Comprador"
              :items="extraData.accountContext.allCollaborators"
              item-value="id"
              item-text="name"
              :disabled="readOnly || partialReadOnly"
              autocomplete="off"
            >
              <template v-slot:append-outer>
                <PersonNew
                  :inlineAddButton="true"
                  :isCollaborator="true"
                  :newEntry="entry.customer"
                  @entry-created="personCreated"
                  modelNameSingular="Pessoa"
                />
              </template>
            </v-autocomplete>
          </v-col>

          <v-col cols="12" sm="12" md="6">
            <v-text-field v-if="entry.emitName"
              v-model="entry.emitName"
              v-bind="getObject('emitName')"
              label="Fornecedor encontrado na nota"
              readonly
              autocomplete="off"
            />
            <v-autocomplete
              v-model="entry.supplierId"
              v-bind="getObject('supplierId')"
              label="Fornecedor"
              :items="extraData.accountContext.allSuppliers"
              item-value="id"
              item-text="name"
              :disabled="readOnly || partialReadOnly"
              autocomplete="off"
            >
              <template v-slot:append-outer>
                <PersonNew
                  :inlineAddButton="true"
                  :isSupplier="true"
                  :newEntry="entry.supplier"
                  @entry-created="personCreated"
                  modelNameSingular="Pessoa"
                />
              </template>
            </v-autocomplete>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="partialReadOnly">
            <DateField
              :inputData.sync="entry.billDate"
              v-bind="getObject('billDate')"
              label="Data de Faturamento"
              :hasTodayButton="true"
              :hasTodayDate="true"
              :disabled="readOnly"
              autocomplete="off"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="">
            <PurchaseItemsIndex
              :purchaseItems="entry.dummyEntryMovementItemsAttributes"
              :purchaseTotalPrice.sync="itemsTotalPrice"
              :readOnly="readOnly || partialReadOnly"
              :hasTableTitle="true"
              :addAndEdit="false"
            />
          </v-col>

          <v-col cols="12" sm="6" md="2">
            <MaskedTextField
              v-bind="getObject('totalInsuranceValue')"
              :inputData.sync="entry.totalInsuranceValue"
              mask-type="currency"
              label="Seguro"
              prefix="R$"
              persistent-hint
              :disabled="readOnly || partialReadOnly"
              :key="totalInsuranceValueKey"
              @change="totalInsuranceValueKey += 1"
              autocomplete="off"
            >
              <template slot="prependMask">
                <v-icon>mdi-plus</v-icon>
              </template>
            </MaskedTextField>
          </v-col>

          <v-col cols="12" sm="6" md="2">
            <MaskedTextField
              v-bind="getObject('otherExpensesTotalValue')"
              :inputData.sync="entry.otherExpensesTotalValue"
              mask-type="currency"
              label="Outras Despesas"
              prefix="R$"
              persistent-hint
              :disabled="readOnly || partialReadOnly"
              :key="otherExpensesTotalValueKey"
              @change="otherExpensesTotalValueKey += 1"
              autocomplete="off"
            >
              <template slot="prependMask">
                <v-icon>mdi-plus</v-icon>
              </template>
            </MaskedTextField>
          </v-col>

          <v-col cols="12" sm="6" md="2">
            <MaskedTextField
              v-bind="getObject('totalCarriageValue')"
              :inputData.sync="entry.totalCarriageValue"
              mask-type="currency"
              label="Frete"
              prefix="R$"
              persistent-hint
              :disabled="readOnly || partialReadOnly"
              :key="totalCarriageValueKey"
              @change="totalCarriageValueKey += 1"
              autocomplete="off"
            >
              <template slot="prependMask">
                <v-icon>mdi-plus</v-icon>
              </template>
            </MaskedTextField>
          </v-col>

          <v-col cols="12" sm="6" md="2">
            <MaskedTextField
              v-bind="getObject('totalDiscountValue')"
              :inputData.sync="entry.totalDiscountValue"
              mask-type="currency"
              label="Desconto"
              prefix="R$"
              persistent-hint
              :disabled="readOnly || partialReadOnly"
              :key="totalDiscountValueKey"
              @change="totalDiscountValueKey += 1"
              autocomplete="off"
            >
              <template slot="prependMask">
                <v-icon>mdi-minus</v-icon>
              </template>
            </MaskedTextField>
          </v-col>

          <v-col cols="12" sm="12" md="4">
            <div class="title mt-3">
              <v-icon>mdi-equal</v-icon>
              Total da Compra: 
              <b class="headline black--text font-weight-bold ml-2"> {{purchaseTotalPrice | formatCurrency}} </b> 
            </div>
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <DateField
              :inputData.sync="entry.estimatedDeliveryDate"
              v-bind="getObject('estimatedDeliveryDate')"
              label="Data Estimada de Entrega"
              :hasTodayButton="true"
              :disabled="readOnly || partialReadOnly"
              autocomplete="off"
            />
          </v-col>

          <v-col cols="12">
            <v-textarea
              v-model="entry.observation"
              v-bind="getObject('observation')"
              label="Observações"
              outlined
              :disabled="readOnly"
              autocomplete="off"
            ></v-textarea>
          </v-col>

        </v-row>
      </v-tab-item>

      <!-- <v-tab-item>
        <v-row>
          <v-col cols="6">
            <v-autocomplete
              v-model="entry.carriageModalityId"
              v-bind="getObject('carriageModalityId')"
              label="Modalidade do Frete"
              :items="extraData.globalContext.allCarriageModalities"
              item-value="id"
              item-text="text"
              :disabled="readOnly"
            />
          </v-col>

          <v-col cols="6" v-if="false">
            <v-autocomplete
              v-model="entry.carrierId"
              v-bind="getObject('carrierId')"
              label="Transportadora"
              :items="extraData.accountContext.allCarriers"
              item-value="id"
              item-text="name"
              :disabled="readOnly"
            />
          </v-col>

          <v-col cols="3" v-if="false">
            <MaskedTextField
              v-bind="getObject('carrierLicensePlate')"
              :inputData.sync="entry.carrierLicensePlate"
              mask-type="plate"
              label="Placa"
              :disabled="readOnly"
            />
          </v-col>

          <v-col cols="3" v-if="false">
            <v-autocomplete
              v-model="entry.carrierLicensePlateStateId"
              v-bind="getObject('carrierLicensePlateStateId')"
              label="UF Placa"
              :items="extraData.globalContext.allStates"
              item-value="id"
              item-text="shortName"
              :disabled="readOnly"
            />
          </v-col>

          <v-col cols="4">
            <MaskedTextField
              v-bind="getObject('totalCarriageValue')"
              :inputData.sync="entry.totalCarriageValue"
              mask-type="currency"
              label="Valor do Frete"
              prefix="R$"
              persistent-hint
              :disabled="readOnly"
              :key="totalCarriageValueKey"
              @change="totalCarriageValueKey += 1"
            />
          </v-col>

        </v-row>
      </v-tab-item> -->

      <v-tab-item>
        <v-row>
          <v-col cols="12" class="mt-3">
            <PaymentIndex
              :payments="entry.paymentsAttributes"
              :totalPayment.sync="purchaseTotalPayment"
              :paymentLimit="entry.totalPrice"
              :readOnly="readOnly || partialReadOnly"
              modelType="Purchase"
              @installment-update="$emit('installment-update', $event)"
              :hasTableTitle="true"
              tableTitle="Pagamentos"
            />
          </v-col>
        </v-row>
      </v-tab-item>

    </v-tabs>
    
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import DateField from "@shared_components/date_field.vue"
import PurchaseItemsIndex from "@models/purchase_items/index.vue"
import PaymentIndex from "@models/payments/index.vue"
import PersonNew from "@models/people/new.vue"
import BaseUtil from "@shared_components/base_util.vue"
import gql from 'graphql-tag';


export default {
  data() {
    return {
      entryAttributes: {},
      purchaseTotalPayment: 0,
      itemsTotalPrice: 0,
      totalCarriageValueKey: 0,
      otherExpensesTotalValueKey: 0,
      totalInsuranceValueKey: 0,
      totalDiscountValueKey: 0,
      pageLoading: false,
      geralError: false,
      file: null,
      loading: false,
      xmlProds: null,
      respTec: null,
    };
  },
  props: {
    entry: {
      type: Object,
      default: {},
    },
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    partialReadOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {    
    MaskedTextField: MaskedTextField,
    PurchaseItemsIndex: PurchaseItemsIndex,
    DateField: DateField,
    PaymentIndex: PaymentIndex,
    PersonNew: PersonNew,
    BaseUtil: BaseUtil
  },
  watch: {
    "file": function () {
      // console.log("Alterou entry.periodIdsAttribute", this.entry.periodIdsAttribute)
      console.log("file", this.file);
      // this.entry = {};
      // this.entry.nfeXml = "";
      // for (let index = 0; index < this.files.length; index++) {
        const element = this.file;
        var reader = new FileReader();
        var self = this;
        // console.log("self", self);
        reader.readAsDataURL(element);
        reader.onload = function () {
          // console.log(reader.result);
          console.log("selfentry", self.entry);
          const data = reader.result;
          self.entry.nfeXml = element.name+";"+data;
          console.log("all", self.entry);
          self.loadServerEntry();
        };
      // }
    },
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);

    for (var payment in this.entry.paymentsAttributes) {
      if (this.entry.paymentsAttributes[payment] && this.entry.paymentsAttributes[payment].value && !this.entry.paymentsAttributes[payment]._destroy) {
        this.purchaseTotalPayment += this.entry.paymentsAttributes[payment].value;
      }
    }
    this.purchaseTotalPayment = _.round(this.purchaseTotalPayment, 2);

    if (this.entry.totalPrice) {
      this.itemsTotalPrice = 0;
      for (var product in this.entry.dummyEntryMovementItemsAttributes) {
        if (this.entry.dummyEntryMovementItemsAttributes[product] && this.entry.dummyEntryMovementItemsAttributes[product].price && !this.entry.dummyEntryMovementItemsAttributes[product]._destroy) {
          this.itemsTotalPrice += this.entry.dummyEntryMovementItemsAttributes[product].price;
        }
      }
    }
    this.itemsTotalPrice = _.round(this.itemsTotalPrice, 2);
  },
  mounted() {
    // this.entry.cfopId = this.entry.cfopId;
    // console.log("form pur", this.entry);
  },
  computed: {
    purchaseTotalPrice: function() {
      this.itemsTotalPrice = this.itemsTotalPrice ? this.itemsTotalPrice : 0;
      this.entry.totalInsuranceValue = this.entry.totalInsuranceValue ? this.entry.totalInsuranceValue : 0; 
      this.entry.otherExpensesTotalValue = this.entry.otherExpensesTotalValue ? this.entry.otherExpensesTotalValue : 0;
      this.entry.totalCarriageValue = this.entry.totalCarriageValue ? this.entry.totalCarriageValue : 0;
      this.entry.totalDiscountValue = this.entry.totalDiscountValue ? this.entry.totalDiscountValue : 0;

      return this.entry.totalPrice = this.itemsTotalPrice 
                                     + this.entry.totalInsuranceValue 
                                     + this.entry.otherExpensesTotalValue
                                     + this.entry.totalCarriageValue
                                     - this.entry.totalDiscountValue;
    }
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },

    loadServerEntry: function () {
      this.pageLoading = true;
      this.$apollo
        .query({
          query: IMPORT_PURCHASE_MUTATION,
          fetchPolicy: "no-cache",
          variables: {
            file: this.entry.nfeXml,
          }
        })
        .then(response => {
            console.log("resp", response.data);
            // this.entry = response.data.accountContext.importPurchase;
            Object.assign(this.entry, response.data.accountContext.importPurchase);
            // this.entry = response.data.accountContext.importPurchase;
            // this.entry.supplierId = response.data.accountContext.importPurchase.supplierId;
            // console.log("assign",this.entry);
            // this.extraData=response.data;
            this.entryLoaded=true;
          // var errors = response.data.createAgrotoxic.errors
          // if (errors.length) {
          //   this.formErrors = errors
          // } else {
          //   this.$refs.baseNew.closeDialog();
          //   this.$emit("entry-created", response.data.createAgrotoxic.item);
          //   if (saveAndAddOther) {
          //     this.loadServerEntry();
          //     this.$refs.baseNew.newDialog = true;
          //   }
          // }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError) {
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors) {
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },

    searchPeople: function(emit, cnpj) {
      // this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: PEOPLE_QUERY,
          fetchPolicy: "no-cache",
          variables:{
            cnpj: cnpj,
          }
        })
        .then(response => {
          if(emit){
            this.entry.supplierId = response.data.accountContext.peopleByCnpj.id;
          }else{
            this.entry.customerId = response.data.accountContext.peopleByCnpj.id;
          }
          // this.extraData = response.data;
          // this.extraData.activeTab = 0;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    searchProds: function(cnpj) {
      // this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: ENTRY_ITEMS_QUERY,
          fetchPolicy: "no-cache",
          variables:{
            supplierDocument: cnpj,
            xmlProds: this.xmlProds,
            respTec: this.respTec,
          }
        })
        .then(response => {
          
          
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        if(this.entry.paymentsAttributes.length > 0){
          this.geralError = true;
        }else{
          this.geralError = false;
        }
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
    personCreated: function(person) {
      //testar pra ver se o tipo é supplier
      if (person.isSupplier) {
        this.extraData.accountContext.allSuppliers.unshift(person);
        this.entry.supplierId = person.id;
        this.entry.supplier = person;
      } else {
        this.$refs.util.showErrorMessage("A pessoa cadastrada não é do tipo Fornecedor, por isso não irá aparecer na lista de fornecedores!");
      }
    }
  }
};


const PEOPLE_QUERY = gql `
  query($cnpj: String!) {
    accountContext{
      peopleByCnpj(cnpj: $cnpj) {
        id
      }
    }
  }
`;

const ENTRY_ITEMS_QUERY = gql `
  query($supplierDocument: String!, $xmlProds: String!, $respTec: String!) {
    accountContext{
      searchProds(supplierDocument: $supplierDocument, xmlProds: $xmlProds, respTec: $respTec) {
        id
      }
    }
  }
`;

const IMPORT_PURCHASE_MUTATION = gql`
  query($file: String!) {
    accountContext{
      importPurchase(file: $file) {
        id
        code
        cfopId
        billDate
        series
        number
        estimatedDeliveryDate
        orderValidity
        supplierId
        supplier{
          name
          kind
          cpf
          cnpj
          validations
          isCarrier
          isDriver
          isCustomer
          isCollaborator
          isEmployee
          isSupplier
          recipientStateInscription
          patrimoniesAttributes {
            id
          }
          taxPayersAttributes {
            id
          }
          customerCulturesAttributes {
            id
            harvestId
            harvest{
              id
              name
            }
            cultureId
            culture{
              id
              name
            }
            plantedArea
            globalArea
            irrigatedArea
            produced
            rentedQuantity
            isRented
          }
          salePackagingsAttributes{
            packagingId
            packaging{
              id
              name
            }
            itemId
            item{
              id
              name
            }
          }
          addressesAttributes{
            stateId
            cityId
            city{
              id
              name
              state{
                id
              }
            }
            street
            neighborhood
            number
            postalCode
          }
        }
        customerId
        customer{
          name
          kind
          cpf
          cnpj
          validations
          isCarrier
          isDriver
          isCustomer
          isCollaborator
          isEmployee
          isSupplier
          patrimoniesAttributes {
            id
          }
          taxPayersAttributes {
            id
          }
          customerCulturesAttributes {
            id
            harvestId
            harvest{
              id
              name
            }
            cultureId
            culture{
              id
              name
            }
            plantedArea
            globalArea
            irrigatedArea
            produced
            rentedQuantity
            isRented
          }
          salePackagingsAttributes{
            packagingId
            packaging{
              id
              name
            }
            itemId
            item{
              id
              name
            }
          }
          addressesAttributes{
            stateId
            cityId
            city{
              id
              name
              state{
                id
              }
            }
            street
            neighborhood
            number
            postalCode
          }
        }
        emitName
        buyerName
        totalPrice
        validations
        totalCarriageValue
        totalDiscountValue
        totalInsuranceValue
        otherExpensesTotalValue
        observation
        dummyEntryMovementItemsAttributes {
          id
          price
          quantity
          importItemName
          hasLot
          enabledLots
          itemId
          item {
            id
            name
            description
            unit {
              name
            }
          }
          dummyEntryMovementItemLotsAttributes{
            dueDate
            manufacturingDate
            lotNumber
            quantity
            packagingQuantity
          }
          packagingId
          packaging {
            id
            name
            unitName
          }
          storageId
          storage {
            id
            name
            location
          }
          validations
        }
        paymentsAttributes {
          id
          code
          bankAccountId
          paymentMethodId
          value
          initialDate
          installmentsInterval {
            id
          }
          paymentConditionId
          paymentCondition {
            id
            description
            numberOfInstallments
          }
          paymentMethod {
            id
            name
          }
          bankAccount {
            id
            name
          }
          installmentsAttributes {
            id
            value
            originalValue
            customCode
            dueDate
            code
            status
            statusKey
            statusColor
            paidAmount
            paymentDate
            bankAccount {
              id
              name
            }
          }
        } 
      }
      allSuppliers {
        id
        name
      }
      allCollaborators{
        id
        name
      }
      allPurchaseCfops{
        id
        text
      }
    }
    globalContext {
      allPaymentConditions {
        id
        description
        numberOfInstallments
      }
      allStates {
        id
        shortName
      }
    }
  }
`;
</script>

<style scoped>
  #purchaseSummary {
    color: gray;
  }
</style>
